import { CommonModule } from '@angular/common';
import { MembershipRestrictionComponent } from '../../membership-restriction/membership-restriction.component';
import { CommonServices } from 'src/app/services/gz.common.services';

import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MyService } from 'src/app/services/myservice';

@Component({
    selector: 'app-webinar-generator',
    standalone: true,
    templateUrl: './linkedin-comments-insights.component.html',
    styleUrls: ['./linkedin-comments-insights.component.scss'],
    imports: [
        MembershipRestrictionComponent, CommonModule
    ]

})
export class LinkedinCommentsInsightsComponent {
    isPageAccess: boolean = false;

    ngOnInit(): void {
        this.checkAccess();
        this.activatedRoute.data.subscribe((response: any) => {
            this.isPageAccess = response.access;
        });
        this.myservice.setTitleAndMeta("LinkedIn Insights","LinkedIn comments and posts insights. Given a post or comments, derive the insights for a successful campaign.","linkedin comments insights, linkedin posts insights, social insights, social media","NA");
    }


    transcript = '';
    recognition: any;


    constructor(
        private authservice: AuthenticationService,
        private activatedRoute: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        private myservice: MyService
    ) {
        const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
        if (!SpeechRecognition) {
            alert('Speech recognition is not supported in this browser.');
            return;
        }

        this.recognition = new SpeechRecognition();
        this.recognition.lang = 'hi-IN'; // Set the language
        this.recognition.interimResults = true; // Show interim results
        this.recognition.continuous = true; // Keep recognition active even after pauses

        // Handle results event
        this.recognition.onresult = (event: any) => {
            let interimTranscript = '';
            let finalTranscript = '';

            // Iterate over results
            for (const result of event.results) {
                if (result.isFinal) {
                    finalTranscript += result[0].transcript;
                } else {
                    interimTranscript += result[0].transcript;
                }
            }

            // Update the transcript with final and interim results
            this.transcript = finalTranscript + interimTranscript;

            // Trigger change detection to update the UI
            this.cdr.detectChanges();
        };

        // Handle error event
        this.recognition.onerror = (event: any) => {
            console.error('Speech recognition error:', event);
        };

        this.recognition.onend = () => {
            console.log('Speech recognition service disconnected. Restarting...');
            this.startRecognition(); 
        };
    }

    startRecognition() {
        if (this.recognition) {
            this.recognition.start();
        }
    }
    stopRecognition() {
        this.recognition.stop();

    }

    isLoggedIn: boolean = false;
    checkAccess(): void {
        this.isLoggedIn = this.authservice.isLoggedIn();
        console.log('user logged in for modal ', this.isLoggedIn)
    }



}
